import { Controller } from "@hotwired/stimulus"

// 30분 단위 시간 선택 모달 컨트롤러
export default class extends Controller {
  static targets = ["modal", "timeList", "input", "selectedTime"]
  static values = {
    startHour: { type: Number, default: 6 },
    endHour: { type: Number, default: 22 }
  }

  connect() {
    this.updateDisplay()
    this.renderTimeList()
  }

  // 다양한 시간 형식에서 HH:MM 추출
  extractTime(value) {
    if (!value) return ''

    // ISO 형식 (2000-01-01T10:30:00)
    if (value.includes('T')) {
      const timePart = value.split('T')[1]
      return timePart ? timePart.substring(0, 5) : ''
    }

    // 공백으로 구분된 날짜시간 (2000-01-01 10:30:00)
    if (value.includes(' ')) {
      const parts = value.split(' ')
      const timePart = parts[1] || parts[0]
      return timePart.substring(0, 5)
    }

    // HH:MM:SS 또는 HH:MM 형식
    return value.substring(0, 5)
  }

  updateDisplay() {
    const rawValue = this.inputTarget.value || ''
    const currentValue = this.extractTime(rawValue)

    if (currentValue && this.hasSelectedTimeTarget) {
      this.selectedTimeTarget.textContent = currentValue
      this.selectedTimeTarget.classList.remove('text-gray-400')
      this.selectedTimeTarget.classList.add('text-gray-900')
    }
  }

  openModal(event) {
    event.preventDefault()
    this.modalTarget.showModal()
    this.renderTimeList()
  }

  closeModal() {
    this.modalTarget.close()
  }

  renderTimeList() {
    const rawValue = this.inputTarget.value || ''
    const currentValue = this.extractTime(rawValue)
    const times = []

    for (let hour = this.startHourValue; hour <= this.endHourValue; hour++) {
      for (let min = 0; min < 60; min += 30) {
        const time = `${hour.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}`
        times.push(time)
      }
    }

    this.timeListTarget.innerHTML = times.map(time => `
      <button type="button"
              class="px-3 py-2 text-sm rounded-lg transition-colors ${time === currentValue ? 'bg-blue-500 text-white font-medium' : 'bg-gray-100 hover:bg-gray-200 text-gray-700'}"
              data-action="click->time-picker#selectTime"
              data-time="${time}">
        ${time}
      </button>
    `).join('')
  }

  selectTime(event) {
    const time = event.currentTarget.dataset.time

    // hidden input 업데이트
    this.inputTarget.value = time

    // 선택된 시간 표시
    this.selectedTimeTarget.textContent = time
    this.selectedTimeTarget.classList.remove('text-gray-400')
    this.selectedTimeTarget.classList.add('text-gray-900')

    // 모달 닫기
    this.closeModal()
  }

  // ESC 키로 모달 닫기
  handleKeydown(event) {
    if (event.key === "Escape") {
      this.closeModal()
    }
  }

  // 모달 외부 클릭 시 닫기
  handleBackdropClick(event) {
    if (event.target === this.modalTarget) {
      this.closeModal()
    }
  }

  // 시간 초기화
  clearTime(event) {
    event.preventDefault()
    this.inputTarget.value = ""
    this.selectedTimeTarget.textContent = "시간을 선택하세요"
    this.selectedTimeTarget.classList.add('text-gray-400')
    this.selectedTimeTarget.classList.remove('text-gray-900')
    this.closeModal()
  }
}
